import { useMemo } from "react";
import useQuery from "hooks/useQuery";
import CircuitService from "services/CircuitService";

export const circuitsCacheKey = ["CircuitService.getAll"] as const;

const DEDUPING_INTERVAL = 30000; // 30 seconds

interface UseGetAllCircuitsQueryOptions {
  /** When false the query is disabled (no fetch); used to skip the fetch for orgs without the custom-exercise entitlement (circuits reuse that policy). */
  enabled?: boolean;
}

/**
 * Fetches the organisation's circuits. The SWR cache is the org-scoped store the
 * MetadataProvider and other circuit surfaces share — auth scopes the request to
 * the active org, so the key needs no org id.
 */
function useGetAllCircuitsQuery(options?: UseGetAllCircuitsQueryOptions) {
  const { enabled = true } = options || {};
  const { data, ...rest } = useQuery(enabled ? circuitsCacheKey : null, () => CircuitService.getAll(), {
    dedupingInterval: DEDUPING_INTERVAL,
  });

  return useMemo(() => ({ data: data ?? [], ...rest }), [data, rest]);
}

export default useGetAllCircuitsQuery;
